import { Button } from '~/components/button'
import type { IButtonBadgeProps } from '../../types'
import { useMemo } from 'react'
import type { IconName } from '@raiadrogasil/pulso-icons'

export const Chat = (props: IButtonBadgeProps) => {
  const symbol = useMemo(() => {
    const counter = props.counter

    if (!counter || counter === 0) return "rdicon-chat"
    if (counter > 9) return "rdicon-chat-multicolor-plus"
    return "rdicon-chat-multicolor"

  }, [props.counter]) as IconName

  const bulletSymbol = useMemo(() => {
    const counter = props.counter

    if (!counter) return
    if (counter <= 9) return `rdicon-bullet-notification-${counter}`
    return 'rdicon-bullet-notification-9-plus'
  }, [props.counter]) as IconName

  return (
    <Button.Root variant="neutral-tertiary" {...props}>
      <Button.Icon symbol={symbol} />
      {props.counter && <Button.Icon symbol={bulletSymbol} iconColor="colorActionTextOnbrandDefault" />}
    </Button.Root>
  )
}
